import { Component, createMemo, Show } from "solid-js";
import { Mason } from "./masonry2";
import { createMasonryBreakpoints } from "solid-mason";

type PrimaryImage = {
  Width: number;
  Height: number;
  URL: string;
}

export type ArtworkItem = {
  Id: string;
  Title: string;
  URL: string;
  Width: number;
  Height: number;
  PrimaryImage: PrimaryImage;
}

type ArtworkGalleryProps = {
  isLoggedIn: boolean;
  artworks: ArtworkItem[];
  onAddToCollectionClicked: (item: ArtworkItem) => void;
}

export const ArtworkMasonry : Component<ArtworkGalleryProps> = (props) => {
  const breakpoints = createMasonryBreakpoints(() => [
    { query: '(min-width: 1536px)', columns: 6 },
    { query: '(min-width: 1280px) and (max-width: 1536px)', columns: 5 },
    { query: '(min-width: 1024px) and (max-width: 1280px)', columns: 4 },
    { query: '(min-width: 768px) and (max-width: 1024px)', columns: 3 },
    { query: '(max-width: 768px)', columns: 2 },
  ]);
  const _getImageHeight = (item: ArtworkItem, columnWidth: number) => {
    const ratio = columnWidth / item.Width;
    const newHeight = item.Height * ratio;
    return Math.ceil(newHeight);
  }
  const getImageHeight = createMemo(() => {
    return (item: ArtworkItem, columnWidth: number) => {
      return _getImageHeight(item, columnWidth);
    };
  }, []);
  return (
    <Mason as="div" items={props.artworks} columns={breakpoints()}>{(item, index, columnWidth) =>
      <div style="position: relative;">
        <a href={item.URL}>
          <img
            src={item.PrimaryImage.URL + `?mode=crop&format=JPEG&width=${Math.ceil(columnWidth)}&height=${getImageHeight()(item, columnWidth)}`}
            style={`width: ${Math.ceil(columnWidth)}px; height: ${getImageHeight()(item, columnWidth)}px; padding: 5px; border-radius: 1em;`}
            alt={item.Title}
            title={item.Title}
          />
        </a>
        <Show when={props.isLoggedIn}>
            <div style="position: absolute; top: 15px; right: 15px; font-size: 1.25rem; color: goldenrod;">
                <span class="fa fa-star" title="Add to your collections" onClick={(e) => { e.preventDefault(); props.onAddToCollectionClicked(item) }}></span>
            </div>
        </Show>
      </div>
    }</Mason>
  )
}
